export default __webpack_public_path__ + "static/media/guesty_lite_step5.9c04d601.png";